import { Directive, HostBinding } from '@angular/core';

@Directive({
  selector: '[sammanvagningCardIcon]',
})
export class SammanvagningCardIconDirective {
  constructor() {}
}
